/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Auto_CorrectionsInputs */



/**
* | output |
* | --- |
* | "Apply Auto Corrections" |
*
* @param {Apply_Auto_CorrectionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_auto_corrections = /** @type {((inputs?: Apply_Auto_CorrectionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Auto_CorrectionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer les corrections automatiques")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Korrekturen anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica correzioni automatiche")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить автоматическую коррекцию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar correcciones automáticas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用自动更正")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正を適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित सुधार लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar correções automáticas")
	return /** @type {LocalizedString} */ ("Apply Auto Corrections")
});